import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import {
  hasModuleAccess,
  hasPermission,
} from "../../../shared/utils/permissions";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/admin/fsm-workflows")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  // Allow entry with EITHER FSM workflow access OR read-only document-types access —
  // sub-routes (e.g. document-types) apply their own finer-grained gating.
  beforeLoad: ({ context }) => {
    const canFsm = hasPermission(context.auth.user, "admin.fsmWorkflows");
    const canReadDocTypes = hasModuleAccess(
      context.auth.user,
      "admin.documentTypes",
      "read",
    );
    if (!canFsm && !canReadDocTypes) {
      throw redirect({ to: "/app" });
    }
  },
  component: () => <Outlet />,
});
